import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FIGMA_EMBED_ROUTE_PREFIX } from '@/consts/auth.consts';
import { FIGMA_EMBED_MESSAGE_TYPES } from '@/consts/figma-embed-messages';
import { useIsFigmaEmbedMode } from '@/contexts/FigmaEmbedModeContext';
import { log } from '@/logger/logger';

const logger = log.getLogger('FigmaEmbedNavigationGuard');

export function FigmaEmbedNavigationGuard(): null {
  const isFigmaEmbedMode = useIsFigmaEmbedMode();
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isFigmaEmbedMode) return;
    if (pathname.startsWith(FIGMA_EMBED_ROUTE_PREFIX)) return;

    logger.warn('Blocked navigation off embed route; redirecting parent to files', {
      pathname,
    });
    window.parent.postMessage({ type: FIGMA_EMBED_MESSAGE_TYPES.outbound.BACK_TO_FILES }, '*');
  }, [isFigmaEmbedMode, pathname]);

  return null;
}
